<template>
	<svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24">
		<path d="M8.617,3.658l0,3.575l2.633,0l-2.075,9.534l-3.325,0l0,3.575l9.533,0l0,-3.575l-2.633,0l2.075,-9.534l3.325,0l0,-3.575l-9.533,0Z" style="fill-rule:nonzero;"/>
	</svg>
</template>
